import { TodoSettingType, TodoSetting } from 'owa-todo-settings';
import { assertNever } from 'owa-assert';

export function truthySettingsValue(settingType: TodoSettingType) {
    return (setting: TodoSetting): boolean => {
        if (settingType !== setting.Key) {
            return false;
        }
        switch (settingType) {
            case TodoSettingType.ListFlagged_Enabled:
                return setting.Value === 'true' ? true : false;
            case TodoSettingType.ListFlagged_OnboardingLastDismissed:
                return setting?.Value ? true : false;
            default:
                return assertNever(settingType);
        }
    };
}
